module.exports = __webpack_public_path__ + "media/images/main/team-8deebd3212ec592f28019ee6a8665137.jpg";